import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { CardProps } from "@/types/AppTypes";
import { capitalizeWords } from "@/utils/helper/capitalizeWords";
import { Link } from "react-router-dom";

const CustomCard: React.FC<CardProps> = ({
  name = "",
  description = "",
  image = "",
  cardLink = "",
  icon = null,
  className = "",
  gradient = "",
  item = null,
  isCategory = false,
}) => {
  const cardContent = (
    <>
      {!isCategory && (
        <CardHeader className="flex items-center justify-center px-0 mx-0">
          {icon ? (
            <div className="mb-4 pt-4 flex items-center justify-center">{icon}</div>
          ) : (
            <div className="w-full flex items-center justify-center group-hover:scale-105 transition-transform duration-300 rounded-t-lg">
              <div className="w-full flex items-center justify-center group-hover:scale-105 transition-transform duration-300 rounded-t-lg">
                <img
                  src={item?.image || image || "/placeholder.webp"}
                  alt={`${item?.name} `}
                  className="h-44 w-full object-fill rounded-t-lg"
                />
              </div>
            </div>
          )}
        </CardHeader>
      )}
      <CardContent
        className={cn(
          "flex flex-col items-center justify-center px-4 py-3 text-center",
          isCategory && "py-12"
        )}
      >
        <CardTitle className="text-base md:text-lg font-medium my-1">
          {capitalizeWords(item?.name || name || "Title ")}
        </CardTitle>
        <CardDescription className="text-sm text-[#888686] overflow-hidden max`-w-full hyphens-auto">
        {description || ""}
        </CardDescription>
      </CardContent>
    </>
  );

  return (
    <Card
      className={cn(
        "group h-full pb-2 pt-0 hover:border  hover:border-black cursor-pointer",
        className,
        gradient
      )}
    >
      {cardLink ? <Link to={`${cardLink}/${item?.id}`}>{cardContent}</Link> : cardContent}
    </Card>
  );
};

export default CustomCard;
